import {
  MACHINE_CREATE_FAIL,
  MACHINE_CREATE_REQUEST,
  MACHINE_CREATE_RESET,
  MACHINE_CREATE_SUCCESS,
  MACHINE_DELETE_FAIL,
  MACHINE_DELETE_REQUEST,
  MACHINE_DELETE_RESET,
  MACHINE_DELETE_SUCCESS,
  MACHINE_LIST_FAIL,
  MACHINE_LIST_REQUEST,
  MACHINE_LIST_RESET,
  MACHINE_LIST_SUCCESS,
  MACHINE_UPDATE_FAIL,
  MACHINE_UPDATE_REQUEST,
  MACHINE_UPDATE_RESET,
  MACHINE_UPDATE_SUCCESS,
} from '../constants/machineConstants'

export const machineCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case MACHINE_CREATE_REQUEST:
      return {
        loading: true,
        error: '',
        success: false,
        createdMachine: undefined,
      }
    case MACHINE_CREATE_SUCCESS:
      return {
        loading: false,
        success: true,
        createdMachine: action.payload,
        error: '',
      }
    case MACHINE_CREATE_FAIL:
      return {
        success: false,
        createdMachine: undefined,
        loading: false,
        error: action.payload,
      }
    case MACHINE_CREATE_RESET:
      return {}
    default:
      return state
  }
}

export const machineListReducer = (state = { machines: [] }, action) => {
  switch (action.type) {
    case MACHINE_LIST_REQUEST:
      return { ...state, loading: true }
    case MACHINE_LIST_SUCCESS:
      return { loading: false, machines: action.payload }
    case MACHINE_LIST_FAIL:
      return { loading: false, error: action.payload }
    case MACHINE_LIST_RESET:
      return {}
    default:
      return state
  }
}

export const machineUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case MACHINE_UPDATE_REQUEST:
      return { ...state, success: false, error: '', loading: true }
    case MACHINE_UPDATE_SUCCESS:
      return {
        loading: false,
        success: true,
        machine: action.payload,
        error: '',
      }
    case MACHINE_UPDATE_FAIL:
      return {
        success: false,
        loading: false,
        error: action.payload,
        machine: undefined,
      }
    case MACHINE_UPDATE_RESET:
      return {}
    default:
      return state
  }
}

export const machineDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case MACHINE_DELETE_REQUEST:
      return { loading: true }
    case MACHINE_DELETE_SUCCESS:
      return { loading: false, success: true }
    case MACHINE_DELETE_FAIL:
      return { loading: false, error: action.payload }
    case MACHINE_DELETE_RESET:
      return {}
    default:
      return state
  }
}
